import { render, staticRenderFns } from "./BuyersPanel.vue?vue&type=template&id=2d154370&scoped=true&"
import script from "./BuyersPanel.vue?vue&type=script&lang=ts&"
export * from "./BuyersPanel.vue?vue&type=script&lang=ts&"
import style0 from "./BuyersPanel.vue?vue&type=style&index=0&id=2d154370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d154370",
  null
  
)

export default component.exports